import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-error-alert',
  templateUrl: './error-alert.component.html',
  styleUrls: ['./error-alert.component.scss']
})
export class ErrorAlertComponent implements OnInit {

  constructor(
    private _translation: TranslateService
  ) { }
  @Input() error = this._translation.instant('please_try_again');

  ngOnInit(): void {
  }

}
